import React, { useEffect, useState } from 'react'
import { getCashFlowStatement } from '../../utils/ActionCreator';
import CashflowStatementTable from './CashflowStatementTable';
import SpinnerLoader from '../../../../../../../presentationals/Loader/Loader.component';
// import SpinnerLoader from '../../../../../Common/Loader.component';

function CashflowStatement() {

    const [isLoad,setIsLoad] = useState(false);
    const [allData,setAllData] = useState([]);

    const fetchCombineStats=()=>{
        setIsLoad(true);
        getCashFlowStatement((callback)=>{
            setIsLoad(false);
            if(callback.message === "success"){
                setAllData(callback.data);
            }
        },(onErr)=>{
            setIsLoad(false);

        });
    }


    useEffect(()=>{
        fetchCombineStats();
    },[])
  return (
    <>
    {isLoad && <SpinnerLoader />}
    {allData.map((item)=>{
        return (
            <>
                <CashflowStatementTable item ={item?.monthlyData} productName={item?.productName} />
            </>
        )
    })}
    </>
  )
}

export default CashflowStatement